const PREFIX = 'graspil_dashboard_compare_';

// Персональный оверрайд «Сравнения» для конкретного дашборда. `dashboard.default_compare`
// (см. DashboardView.vue) — это общая настройка дашборда, одна на всех; если пользователь
// сам включил или выключил сравнение при просмотре, это его личный выбор, и при следующем
// открытии дашборда default_compare не должен его перезаписывать — поэтому храним в
// localStorage (per-браузер), а не отправляем на бэкенд.
export function getDashboardCompareOverride(dashboardId) {
    if (!dashboardId) return null;
    const raw = localStorage.getItem(PREFIX + dashboardId);
    if (raw === '1') return true;
    if (raw === '0') return false;
    return null;
}

export function setDashboardCompareOverride(dashboardId, enabled) {
    if (!dashboardId) return;
    localStorage.setItem(PREFIX + dashboardId, enabled ? '1' : '0');
}
